import * as React from 'react';

const TailwindBaseModal = ({
	children,
	disabled,
	disableEscDismiss,
	footer,
	title,
	onClose,
	onSubmit,
}: {
	children?: React.ReactNode;
	disabled?: boolean;
	disableEscDismiss?: boolean;
	footer?: React.ReactNode;
	title?: React.ReactNode;
	onClose: () => void;
	onSubmit?: () => void;
}) => {
	React.useEffect(() => {
		if (disableEscDismiss) {
			return;
		}

		const listener = (event: KeyboardEvent) => {
			switch (event.key) {
				case 'Esc':
				case 'Escape':
					onClose();
				default:
					return;
			}
		};
		document.body.addEventListener('keyup', listener);
		return () => {
			document.body.removeEventListener('keyup', listener);
		};
	}, [disableEscDismiss, onClose]);

	const submitHandler = React.useCallback(
		(event: React.FormEvent) => {
			event.preventDefault();
			if (disabled) {
				return;
			}

			onSubmit?.();
		},
		[onSubmit, disabled]
	);

	return (
		<form className='overflow-auto' onSubmit={submitHandler}>
			<i
				className='absolute left-0 top-0 w-full h-full bg-cBlue-800 bg-opacity-70 z-20 erp-overlay hidden_'
				onClick={onClose}
			></i>
			<div
				className='absolute left-0 top-0 w-full h-full p-6 flex items-center justify-center z-30 erp-modal-vol hidden_'
				onClick={onClose}
			>
				<div
					className='flex flex-col w-full max-w-3xl max-h-full bg-white overflow-hidden rounded'
					onClick={(event) => event.stopPropagation()}
				>
					<div className='shrink-0 flex justify-between items-center rounded-t pl-3 pr-2 py-3 bg-cPurple-800'>
						<h2 className='leading-6 text-xl font-display font-medium text-white'>{title || null}</h2>
						<button
							className='p-1 flex-shrink-0 inline-block text-white rounded-full transition bg-white bg-opacity-10 hover:bg-white hover:bg-opacity-100 hover:text-cPurple-800 erp-modal-vol-close'
							type='button'
							onClick={onClose}
						>
							<svg
								className='h-4 w-4'
								fill='none'
								stroke='currentColor'
								strokeWidth='2'
								viewBox='0 0 24 24'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path d='M6 18L18 6M6 6l12 12' strokeLinecap='round' strokeLinejoin='round'></path>
							</svg>
						</button>
					</div>
					<div className='px-3 py-4 bg-white overflow-auto'>{children || null}</div>
					<div className='shrink-0 flex justify-end py-1 px-2.5 border-t border-gray-200 bg-gray-100 bg-opacity-60'>
						{footer || null}
					</div>
				</div>
			</div>
		</form>
	);
};

export default React.memo(TailwindBaseModal);
